export function getIndex(el) {
    return Array.from(el.parentNode.children).indexOf(el)
}

export function getPropHeight(el) {
    return getComputedStyle(el).getPropertyValue("--height")
}